import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  clientSideCellNumber: '',
  clientSideCountryCode: '',
  accessToken: '',
  // loginAccessToken: '',
  isLogin: false,
  clinicData: [],
  fcmToken: 'abc',
  password: '',
  profile: null,
  doctorOpdFees: '',
  settingsData: {
    appointmentDuration: 5,
    smsIsAuto: false,
    smsIsInvoice: false,
    smsIsPrescription: false,
    smsIsCreationOfAppointment: false,
    smsIsRescheduleOfAppointment: false,
    smsIsCancellationOfAppointment: false,
    smsIsAppointmentReminder: false,
    smsAppointmentReminderTime: '1-H',
    smsIsIncludeDoctorNumber: false,
    smsIsIncludePaNumber: false
  },
  appointmentsSettingData: {
    isAppointment: false,
    isFollowUp: false,
    appointmentDuration: 0,
    allowOverlapAppointment: false,
    allowMultiAppointment: true
  }
};
const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action?.payload?.accessToken;
    },
    setLoginAccessToken(state, action) {
      state.loginAccessToken = action.payload?.accessToken;
    },
    SaveFcmToken(state, action) {
      state.fcmToken = action.payload.fcmToken;
    },
    saveLoginUserData(state, action) {
      state.user = action.payload.data.user;
      state.isLogin = true;
      state.accessToken = action.payload.token;
    },
    updateUser(state, action) {
      state.role = action?.payload?.role;
      state.settingsData = action?.payload?.settingsData;
      state.clinicData = action?.payload?.clinicData;
      state.isLogin = true;
      state.accessToken = action?.payload?.accessToken;
    },
    logOutRequest(state) {
      state.accessToken = '';
      state.isLogin = false;
      state.user = null;
    },
    setDoctorOpdFee(state, action) {
      state.doctorOpdFees = action?.payload;
    },

    setPassword(state, action) {
      state.password = action.payload;
    },
    setUserProfile(state, action) {
      state.profile = action?.payload;
    },
    setClientSideCellNumber(state, action) {
      state.clientSideCellNumber = action.payload;
    },
    setClientCountryCode(state, action) {
      state.clientSideCountryCode = action.payload;
    },
    setSettingsData(state, action) {
      // state.settingsData.appointmentDuration = action?.payload?.appointmentDuration;
      // state.settingsData.smsIsAuto = action?.payload?.smsIsAuto;
      // state.settingsData.smsIsInvoice = action?.payload?.smsIsInvoice;
      // state.settingsData.smsIsPrescription = action?.payload?.smsIsPrescription;
      // state.settingsData.smsIsCreationOfAppointment = action?.payload?.smsIsCreationOfAppointment;
      // state.settingsData.smsIsRescheduleOfAppointment =
      //   action?.payload?.smsIsRescheduleOfAppointment;
      // state.settingsData.smsIsCancellationOfAppointment =
      //   action?.payload?.smsIsCancellationOfAppointment;
      // state.settingsData.smsIsAppointmentReminder = action?.payload?.smsIsAppointmentReminder;
      // state.settingsData.smsAppointmentReminderTime = action?.payload?.smsAppointmentReminderTime;
      // state.settingsData.smsAppointmentReminderTime = action?.payload?.smsAppointmentReminderTime;
      // state.settingsData.smsIsIncludeDoctorNumber = action?.payload?.smsIsIncludeDoctorNumber;
      // state.settingsData.smsIsIncludePaNumber = action?.payload?.smsIsIncludePaNumber;
      // smsIsIncludeDoctorNumber: false,
      // smsIsIncludePaNumber: false
    },
    //bcz this appointment section is separate piece
    setAppointmentSetting(state, action) {
      if (!state.appointmentsSettingData) {
        console.error('appointmentsSettingData is undefined, initializing...');
        state.appointmentsSettingData = {};
      }
      state.appointmentsSettingData.allowOverlapAppointment =
        action?.payload?.allowOverlapAppointment;
      state.appointmentsSettingData.allowMultiAppointment = action?.payload?.allowMultiAppointment;
      state.appointmentsSettingData.appointmentDuration = action?.payload?.appointmentDuration;
      state.appointmentsSettingData.isAppointment = action?.payload?.isAppointment;
      state.appointmentsSettingData.isFollowUp = action?.payload?.isFollowUp;
    }
  }
});
export const {
  SaveFcmToken,
  saveLoginUserData,
  logOutRequest,
  updateUser,
  setAccessToken,
  setLoginAccessToken,
  setPassword,
  setUserProfile,
  setClientSideCellNumber,
  setClientCountryCode,
  setDoctorOpdFee,
  setSettingsData,
  setAppointmentSetting
} = authSlice.actions;
export default authSlice.reducer;
